import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/questionnaires/(pages)')({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/questionnaires' ||
      location.pathname === '/questionnaires/'
    ) {
      throw redirect({
        to: '/questionnaires/my-questionnaires/active',
      });
    }
  },
});
